import { useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

const Mylogin = ({ setLoggedIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const login = () => {
    if (email === "" || password === "") {
      swal("Error", "Empty Email or Password", "warning");
    } else {
      // Here, you can store user login information in localStorage
      const userInfo = {
        email: email,
        password: password,
      };

      localStorage.setItem("LoginDetails", JSON.stringify(userInfo));
      swal("Success", "Login successful", "success");
      setLoggedIn(true);
      navigate("/"); // Redirect user to home page or any other desired route after successful login
    }
  };

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        <div className="col-lg-4"></div>
        <div className="col-lg-4">
          <div className="card border-0 shadow-lg">
            <div className="card-header bg-primary text-center text-white">
              {" "}
              Login
            </div>
            {/* card header end */}
            <div className="card-body">
              <div className="mb-3">
                <label> EMail Id</label>
                <input
                  type="email"
                  className="form-control"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
              </div>

              <div className="mb-3">
                <label> Password</label>
                <input
                  type="password"
                  className="form-control"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                />
              </div>
            </div>
            {/*card body end*/}
            <div className="card-footer text-center">
              <button className="btn btn-danger" onClick={login}>
                Login
              </button>
              <p>Don't have an account yet?</p>
              <Link to="/register">Create an account</Link>
            </div>
            {/* card footer end */}
          </div>
        </div>
        <div className="col-lg-4"></div>
      </div>
    </div>
  );
};

export default Mylogin;
